export default __webpack_public_path__ + "static/media/kayra.c01de026.png";